import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const NeosurfPayBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.NEOSURF}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.NEOSURF)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.NEOSURF)} alt="neosurf" />
    </Box>
  );
};
